import { Component, EventEmitter, Input, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'icc-msg-tpl',
  templateUrl: './icc-msg-tpl.component.html',
  styleUrls: ['./icc-msg-tpl.component.less'],
})
export class IccMsgTplComponent implements OnInit {
  @Input() tpl: any;
  // 业务类型编码
  // @Input() code: string;
  // // 发送免审
  // @Input() ignoreAudit: boolean;
  // // 已通过模板数
  // @Input() passed: boolean;
  // // 审核中模板数
  // @Input() handling: boolean;
  // // 被驳回模板数
  // @Input() reject: boolean;
  // 模板状态
  // @Input() status: number;
  // 类型数组
  // @Input() typeList: Array<{
  //   msgType: number;
  //   msgTypeName: string;
  //   count: number;
  // }>;
  // 更新时间
  // @Input() updateTime: Date;
  // // 更新人名称
  // @Input() updateUserName: string;
  // 操作数组
  @Input() actionList: Array<{
    icon: string;
    text: string;
    class?: string;
    click: EventEmitter<any>;
    isAnimation: boolean; // 是否需要动画显示该项，UI定制要求
  }>;
  // 鼠标在操作区
  isHover: boolean;
  // 显示操作区
  showAction: boolean;
  // 鼠标位置
  mouse = {
    x: 0,
    y: 0,
  };
  // 是否按下左键
  isPress: boolean;
  // 是否使用浮动右滑操作菜单
  showSlideMenu = false;

  // 显示btn操作组
  showBtns: boolean;

  animationBtnsWidth: string;

  constructor(private el: ElementRef, private route: Router) {}

  ngOnInit() {
    const selectedList = this.actionList.filter(item => item.isAnimation);
    let width = 0;
    for (const item of selectedList) {
      width = width + 38 + (item.text ? 12 + 14 * item.text.length : 0);
    }
    this.animationBtnsWidth = width + 'px';
  }

  mouseDown(evt) {
    if (this.showAction && !this.isHover) {
      this.showAction = false;
    }
    if (evt.button == 0) {
      this.isPress = true;
    }
    this.mouse.y = evt.clientY;
    this.mouse.x = evt.clientX;
  }
  mouseUp(evt) {
    if (evt.clientX != this.mouse.x && this.isPress) {
      this.showAction = true;
    }
    this.isPress = false;
    this.mouse.y = 0;
    this.mouse.x = 0;
  }
  mouseEnter(evt) {
    this.showAction = true;
  }
  mouseLeave(evt) {
    this.showAction = false;
    this.isPress = false;
    this.mouse.y = 0;
    this.mouse.x = 0;

    this.displayBtnList(false);
  }
  operateClick($event, action) {
    action.click($event, action);
  }
  displayBtnList(isShow) {
    this.showBtns = isShow;
  }

  toDetail() {
    this.route.navigateByUrl('/business/biztype/detail/' + this.tpl.id);
  }
}
